import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { AccountPositionRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface AccountPositionsState {
    [accountId: string]: {
        [assetId: string]: AccountPositionRecord;
    };
}

const initialState: AccountPositionsState = {};
const initialLoadAction = createAction<{ accountPositions: {
    [accountId: string]: {
        [assetId: string]: AccountPositionRecord;
    };
}; }>('InitialLoad');
const accountPositionsRecordAction = createAction<AccountPositionRecord>(CoreMsgTypes.AccountPositionRecord);

const accountPositionsSlice = createSlice({
    name: 'accountPositions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                initialLoadAction,
                (_state, action) => action.payload.accountPositions
            )
            .addCase(
                accountPositionsRecordAction,
                (state, action) => {
                    const { AccountId, AssetId } = action.payload;
                    if (!state[AccountId]) {
                        state[AccountId] = {};
                    }
                    state[AccountId][AssetId] = action.payload;
                }
            )
            .addDefaultCase(state => state);
    }
});

export default accountPositionsSlice.reducer;